import headerImage from '../public/assets/images/shake_around_header.jpg';
import ImageBanner from '../components/ImageBanner';
import BannerTitle from '../components/BannerTitle';
import ShakeAroundContent from '../container/ShakeAroundContent';
import images from '../constants/images';
import ShakeGallery from '../container/ShakeGallery';
import Head from 'next/head';


const ShakeAroundTheWorld = () => (
  <>
    <Head>
      <title>Shaking Crab | Shake Around the World</title>
    </Head>
    <ImageBanner
      image={headerImage}>
      <BannerTitle title={`Shake Around The World`}/>
    </ImageBanner>
    <ShakeAroundContent />
    <ShakeGallery images={images.shakeGallery}/>
  </>
);

export default ShakeAroundTheWorld;
